import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title',
  template: `
    <span class="p-1 border-2 rounded h5"
          [ngStyle]="{'border-color': borderColor, 'color': textColor, 'background-color': backgroundColor}">
      {{ content }}
    </span>
  `,
})
export class TitleComponent {
  @Input() borderColor: string = '1px solid #000';
  @Input() textColor: string = '#fff';
  @Input() backgroundColor: string = 'transparent';
  @Input() content: string | undefined;
}